let featureFlags = {
  accessibleTools: ["renewal", "presentation"],
  renewal: {
    allowCobrandLogoUpload: false
  },
  presentation: {
    hideInteractivity: false,
    showBreadCrumbCheckBox: false,
    showPresentationFilter: true,  // Flag to decide if filter panel has to be shown on Library page.
    showFilter: true, // Flag to decide if the filter tab has to be shown on Admin section in content repository.
    showAdminLayouts: false,
    showImageCategories: true,
    showCustomerLogo: true,
    slideDataAvailable: false,
    hideSecondaryColor: true
  },
  marketingMaterials: {
    allowClientLogoUpload: false,
    showDocumentTitle: false,
    showDownloadDeck: false,
    showContentMasterSideBar: false,
    showUserBulkUpload: false
  }
};

export default featureFlags;
